// src/LandingPage.js
import React from 'react';
import styles from './ChatApp.module.css';

const MicIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line></svg>
);
const CameraIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
);

// --- Feature Section Icons (Standardized 24x24  ---

const FeatMicIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
        <line x1="12" y1="19" x2="12" y2="23"></line>
        <line x1="8" y1="23" x2="16" y2="23"></line>
    </svg>
);

const FeatChatIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
    </svg>
);

const FeatWhatsAppIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
         <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
    </svg>
);

const FeatCameraIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
        <circle cx="12" cy="13" r="4"></circle>
    </svg>
);

const FeatListIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
        <path d="M9 12h6"></path>
        <path d="M9 16h6"></path>
    </svg>
);

const FeatDraftIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
);

const ZapIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
);
const DatabaseIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path></svg>
);
const DashboardIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="3" width="7" height="9"></rect><rect x="14" y="3" width="7" height="5"></rect><rect x="14" y="12" width="7" height="9"></rect><rect x="3" y="16" width="7" height="5"></rect></svg>
);
const CheckIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...props}><polyline points="20 6 9 17 4 12"></polyline></svg>
);
const BriefcaseIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
);
const UserIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
);
const StoreIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M3 3h18v18H3zM2 8h20M12 3v18"></path></svg>
);

const LandingPage = ({ onNavigateToLogin, onNavigateToSignUp }) => {
    return (
        <div className={styles.landingDarkContainer}>
            
            {/* --- Header --- */}
            <header className={styles.landingHeader}>
                <div className={styles.landingNavContainer}>
                    <div className={styles.landingLogo}>
                        <strong>AirGrocer AI</strong> Sales
                    </div>
                    <button 
                        onClick={onNavigateToLogin} 
                        className={styles.heroButtonSecondary}
                    >
                        Login
                    </button>
                </div>
            </header>

            <main className={styles.landingMainContent}>
                
                {/* --- Hero Section --- */}
                <section className={styles.heroSection}>
                    <div className={styles.heroText}>
                        <h1 className={styles.heroHeadline}>
                            Intelligent Sales Engine
                            <br />
                            for F&B Distributors
                        </h1>
                        <p className={styles.heroSubheadline}>
                            Protect your margins. Track price changes. Know your best products.<br />
                            24/7 ordering through <span className={styles.highlightText}>voice, photos, and chat.</span>
                        </p>
                        <div className={styles.heroActions}>
                            <button 
                                onClick={() => window.open('https://koalendar.com/e/meet-with-david-59')} 
                                className={styles.heroButtonPrimary}
                            >
                                Book a Demo
                            </button>
                        </div>
                    </div>
                    
                    <div className={styles.heroVisualPhone}>
                        <div className={styles.heroMockupPhone}>
                            <div className={styles.mockupHeader}>
                                <strong>AirGrocer AI</strong>
                                <span>Order for Corner Mart</span>
                            </div>
                            <div className={styles.mockupChatBody}>
                                <div className={styles.demoChatScroll}>
                                    {/* Conversation Set 1 */}
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <MicIcon /> <span>"Add 5 cases of San Pelegrino..."</span>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <CameraIcon /> <span>[Photo of chip aisle]</span>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <pre>Pasted List:
                                            <br />10x Kettle 5oz SS
                                            <br />5x Haribo Frogs
                                        </pre>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleAgent}`}>
                                        <span className={styles.agentName}>David's AI</span>
                                        All set! I've combined your voice, photo, and list. Here's the order:
                                        <ul>
                                            <li>5x SAN PELEGRINO</li>
                                            <li>12x KETTLE (From Photo)</li>
                                            <li>10x KETTLE (From List)</li>
                                            <li>5x HARIBO FROGS</li>
                                        </ul>
                                        Total: $754.45. Ready to confirm?
                                    </div>
                                    {/* Conversation Set 2 (Loop) */}
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <MicIcon /> <span>"Add 5 cases of San Pelegrino..."</span>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <CameraIcon /> <span>[Photo of chip aisle]</span>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleUser}`}>
                                        <pre>Pasted List:
                                            <br />10x Kettle 5oz SS
                                            <br />5x Haribo Frogs
                                        </pre>
                                    </div>
                                    <div className={`${styles.mockChatBubble} ${styles.mockBubbleAgent}`}>
                                        <span className={styles.agentName}>David's AI</span>
                                        All set! I've combined your voice, photo, and list. Here's the order:
                                        <ul>
                                            <li>5x SAN PELEGRINO</li>
                                            <li>12x KETTLE (From Photo)</li>
                                            <li>10x KETTLE (From List)</li>
                                            <li>5x HARIBO FROGS</li>
                                        </ul>
                                        Total: $754.45. Ready to confirm?
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className={styles.mergedSection}>

                    {/* --- Ordering Intelligence --- */}
                    <div style={{marginBottom: '60px'}}>
                        <h2 className={styles.sectionTitle}>
                            Ordering Powered by Intelligence
                        </h2>
                        {/* Grid for the 6 items */}
                        <div style={{
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
                            gap: '20px',
                            textAlign: 'center'
                        }}>
                             {/* Item 1: Voice notes */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px'}}>
                                    <FeatMicIcon />
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>Voice Notes</h3>
                             </div>

                             {/* Item 2: Chat */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px'}}>
                                    <FeatChatIcon />
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>Chat</h3>
                             </div>

                             {/* Item 3: WhatsApp */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px', background: 'var(--card-bg-dark)', border: '1px solid #25D366', color: '#25D366'}}>
                                    <FeatWhatsAppIcon /> 
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>WhatsApp</h3>
                             </div>

                             {/* Item 4: Shelf Photos */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px'}}>
                                    <FeatCameraIcon />
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>Shelf Photos</h3>
                             </div>

                             {/* Item 5: Lists */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px'}}>
                                    <FeatListIcon />
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>Pasted Lists</h3>
                             </div>

                             {/* Item 6: Rapid Draft */}
                             <div className={styles.featureCard} style={{padding: '20px', alignItems: 'center'}}>
                                <div className={styles.featureIconWrapper} style={{margin: '0 auto 15px', background: 'var(--accent-lime-light)', color: 'var(--accent-lime)'}}>
                                    <FeatDraftIcon />
                                </div>
                                <h3 className={styles.featureTitle} style={{fontSize: '1.1rem'}}>Rapid Draft</h3>
                             </div>
                        </div>
                        <p style={{textAlign: 'center', marginTop: '30px', fontSize: '1.1rem', color: 'var(--text-secondary)'}}>
                            <span>Let customers and sales reps order the way they already do</span>
                        </p>
                    </div>

                    
                    {/* Who it is for */}
                    <div>
                         <h2 className={styles.sectionTitle}>
                            More selling, Less data entry.
                        </h2>
                        
                        <div className={styles.personaGrid}>
                            {/* Distributor Card */}
                            <div className={styles.personaCard}>
                                <div className={styles.personaIcon}>
                                    <BriefcaseIcon />
                                </div>
                                <div className={styles.personaSubtitle}>For Distributors</div>
                                <h3 className={styles.personaTitle}>The Command Center</h3>
                                <ul className={styles.personaList}>
                                    <li><CheckIcon className={styles.checkIcon} /> Custom pricing</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Store-specific catalogs</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Live performance dashboards</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Manage all orders in one hub</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Syncs with your existing ERP</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Multi-user access</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Sales rep targets and commission tracking</li>
                                </ul>
                            </div>

                            {/* Sales Rep Card */}
                            <div className={styles.personaCard}>
                                <div className={styles.personaIcon}>
                                    <UserIcon />
                                </div>
                                <div className={styles.personaSubtitle}>For Sales Reps</div>
                                <h3 className={styles.personaTitle}>The Road Champion</h3>
                                <ul className={styles.personaList}>
                                    <li><CheckIcon className={styles.checkIcon} /> Order via voice, photo, or chat</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Instant SKU search</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Eliminate manual data entry</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Track commissions & targets</li>
                                    <li><CheckIcon className={styles.checkIcon} /> View personal sales stats instantly</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Get instant answers from product and sales data with smart querying</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Store history and reorder templates</li>
                                </ul>
                            </div>

                            {/* Retailer Card */}
                            <div className={styles.personaCard}>
                                <div className={styles.personaIcon}>
                                    <StoreIcon />
                                </div>
                                <div className={styles.personaSubtitle}>For Stores</div>
                                <h3 className={styles.personaTitle}>The Busy Manager</h3>
                                <ul className={styles.personaList}>
                                    <li><CheckIcon className={styles.checkIcon} /> Order via voice, photo, or chat</li>
                                    <li><CheckIcon className={styles.checkIcon} /> No more waiting on hold</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Instantly recall past orders through AI chat</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Instant sales report</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Get instant answers from products with smart querying</li>
                                    <li><CheckIcon className={styles.checkIcon} /> Eliminate stock outs with set-and-forget auto-replenishment</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Divider */}<br />
                    <div className={styles.gridSpacer}></div>

                </section>

                {/* --- Pricing Section --- */}
                <section className={styles.pricingSection}>
                    <h2 className={styles.sectionTitle}>Simple, Transparent Pricing</h2>
                    <div className={styles.pricingGrid}>
                        
                        {/* Basic Plan */}
                        <div className={styles.pricingCard}>
                            <h3 className={styles.pricingTitle}>Starter Plan</h3>
                            <div className={styles.pricingPrice}>$499<span className={styles.pricingPeriod}>/month</span></div>
                            <p className={styles.pricingDesc}>Essential AI features for growing distribution businesses.</p>
                            
                            <ul className={`${styles.personaList} ${styles.pricingFeatures}`}>
                                <li><CheckIcon className={styles.checkIcon} /> Margin and price insights</li>
                                <li><CheckIcon className={styles.checkIcon} /> Fast and slow mover breakdown</li>
                                <li><CheckIcon className={styles.checkIcon} /> Unlimited stores</li>
                                <li><CheckIcon className={styles.checkIcon} /> Photo and text ordering</li>
                                <li><CheckIcon className={styles.checkIcon} /> Email support</li>
                                <li><CheckIcon className={styles.checkIcon} /> Standard ERP integration</li>
                                <li><CheckIcon className={styles.checkIcon} /> One sales rep seat included</li>
                            </ul>
                            <button onClick={() => window.open('https://koalendar.com/e/meet-with-david-59')} className={`${styles.pricingButton} ${styles.btnOutline}`}>Get Started</button>
                        </div>

                        {/* All-In Plan (Highlighted) */}
                        <div className={`${styles.pricingCard} ${styles.pricingCardFeatured}`}>
                            <div className={styles.popularBadge}>Most Popular</div>
                            <h3 className={styles.pricingTitle} style={{color: 'var(--accent-lime)'}}>All-In Plan</h3>
                            <div className={styles.pricingPrice}>$799<span className={styles.pricingPeriod}>/month</span></div>
                            <p className={styles.pricingDesc}>Supercharge your sales pipeline with complete AI Automation.</p>
                            
                            <ul className={`${styles.personaList} ${styles.pricingFeatures}`}>
                                <li><CheckIcon className={styles.checkIcon} /> Everything in the Starter Plan</li>
                                <li><CheckIcon className={styles.checkIcon} /> Voice-to-Order (Audio)</li>
                                <li><CheckIcon className={styles.checkIcon} /> Advanced analytics dashboard</li>
                                <li><CheckIcon className={styles.checkIcon} /> Custom catalog rules</li>
                                <li><CheckIcon className={styles.checkIcon} /> Priority support</li>
                                <li><CheckIcon className={styles.checkIcon} /> Three sales rep seats included</li>
                            </ul>
                            <button onClick={() => window.open('https://koalendar.com/e/meet-with-david-59')} className={`${styles.pricingButton} ${styles.btnSolid}`}>Get All-In</button>
                        </div>

                    </div>
                </section>

            </main>

            {/* --- Footer --- */}
            <footer className={styles.landingFooter}>
                <div className={styles.landingNavContainer}>
                    <div className={styles.landingLogo} style={{fontSize: '20px'}}>
                        <strong>AirGrocer AI</strong> Sales
                    </div>
                    <p style={{fontSize: '18px'}}><span>&#9993;</span> support@airgrocer.ai</p>
                    <p>© 2025 AirGrocer AI Sales. <br />The future of F&B distribution.</p>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;